import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'

const Paragraph = ({ text }) => (
  <Typography gutterBottom variant="body1" sx={{ textAlign: 'left' }}>
    {text}
  </Typography>
)

const Note = ({ text }) => (
  <Typography gutterBottom variant="body2" sx={{ textAlign: 'left', fontStyle: 'italic', opacity: 0.8 }}>
    {text}
  </Typography>
)

const List = ({ items }) => (
  <Typography component="ul" sx={{ textAlign: 'left', pl: 3 }}>
    {items.map((item, index) => (
      <Typography component="li" gutterBottom variant="body1" key={index}>
        {typeof item === 'string'
          ? item
          : <><b>{item.label}</b> {item.text}</>
        }
      </Typography>
    ))}
  </Typography>
)

const DataTable = ({ headers, rows }) => (
  <TableContainer sx={{ my: 2 }}>
    <Table size="small">
      <TableHead>
        <TableRow>
          {headers.map((header) => (
            <TableCell key={header} sx={{ fontWeight: 'bold' }}>{header}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row, rowIndex) => (
          <TableRow key={rowIndex}>
            {row.map((cell, cellIndex) => (
              <TableCell key={cellIndex}>{cell}</TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
)

const Block = ({ block }) => {
  if (block.type === 'paragraph') return <Paragraph text={block.text} />
  if (block.type === 'note') return <Note text={block.text} />
  if (block.type === 'list') return <List items={block.items} />
  if (block.type === 'table') return <DataTable headers={block.headers} rows={block.rows} />

  return null
}

function LegalDocument({ title, lastUpdated, intro, sections }) {
  return (
    <Container maxWidth="md">
      <Typography gutterBottom variant="h2" sx={{ textAlign: 'center' }}>
        {title}
      </Typography>
      <Typography gutterBottom variant="body2" sx={{ textAlign: 'center', opacity: 0.7, mb: 4 }}>
        Last updated: {lastUpdated}
      </Typography>

      <Paragraph text={intro} />

      {sections.map((section) => (
        <div key={section.heading}>
          <Typography gutterBottom variant="h4" sx={{ mt: 4, textAlign: 'left', fontSize: { xs: 26, sm: 30 } }}>
            {section.heading}
          </Typography>
          {section.blocks.map((block, index) => (
            <Block block={block} key={index} />
          ))}
        </div>
      ))}
    </Container>
  )
}

export default LegalDocument
